import { Reveal } from "./Reveal";
import { IMAGES } from "../lib/images";
import { Check } from "lucide-react";

const POINTS = [
    "Solutions shaped around your actual requirements and budget.",
    "Integrated thinking across software, devices, connectivity, and security.",
    "Clear communication from planning through installation and support.",
    "Built to support businesses, organizations, and individual clients.",
];

const FACTS = [
    ["6", "Core service areas"],
    ["On-site", "Installation & setup"],
    ["End-to-end", "Planning to support"],
];

export default function AboutSection() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="bg-white py-20 lg:py-32"
        >
            <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-8 lg:grid-cols-2 lg:gap-16 lg:px-12">
                <Reveal className="order-2 lg:order-1">
                    <span className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-brand">
                        About Lynxtech
                    </span>
                    <h2
                        data-testid="about-title"
                        className="mt-4 font-display text-3xl font-bold tracking-tight text-navy sm:text-4xl"
                    >
                        One technology partner across platforms, systems, and
                        connectivity.
                    </h2>
                    <p
                        data-testid="about-description"
                        className="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg"
                    >
                        Lynxtech IT Solutions provides technology-focused services
                        designed to help businesses, organizations, and clients adopt
                        practical digital solutions. Our offerings cover mobile
                        platforms, software and systems, hardware and networking, CCTV
                        installation, and connectivity solutions.
                    </p>

                    <ul className="mt-7 space-y-3">
                        {POINTS.map((p) => (
                            <li key={p} className="flex items-start gap-3">
                                <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand-50 text-brand">
                                    <Check className="h-3.5 w-3.5" />
                                </span>
                                <span className="text-sm leading-relaxed text-slate-700">
                                    {p}
                                </span>
                            </li>
                        ))}
                    </ul>

                    <div className="mt-9 grid grid-cols-3 gap-4 border-t border-slate-200 pt-7">
                        {FACTS.map(([big, small], i) => (
                            <div
                                key={big}
                                data-testid={`about-fact-${i}`}
                            >
                                <div className="font-display text-2xl font-bold text-brand sm:text-3xl">
                                    {big}
                                </div>
                                <div className="mt-1 text-xs text-slate-500">
                                    {small}
                                </div>
                            </div>
                        ))}
                    </div>
                </Reveal>

                <Reveal className="order-1 lg:order-2" delay={0.1}>
                    <div className="relative">
                        <div
                            className="absolute -inset-3 rounded-3xl bg-gradient-to-br from-brand/20 to-cyan/10 blur-2xl"
                            aria-hidden="true"
                        />
                        <div className="relative overflow-hidden rounded-3xl border border-slate-200 shadow-xl">
                            <img
                                src={IMAGES.about}
                                alt="Technology workstation with development and systems tools"
                                loading="lazy"
                                className="aspect-[4/3] w-full object-cover"
                            />
                        </div>
                        <div className="absolute -bottom-5 left-5 right-5 rounded-2xl border border-slate-200 bg-white/95 p-4 shadow-lg backdrop-blur sm:left-6 sm:w-64">
                            <p className="font-display text-sm font-semibold text-navy">
                                Practical, scalable systems
                            </p>
                            <p className="mt-1 text-xs text-slate-500">
                                Based in Baao, Camarines Sur — serving businesses and
                                individual clients.
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
